import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const swiper = css`
  padding-inline: ${spacing(1)};
`

export const slide = css`
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-self: flex-end;
`

export const banner = css`
  padding-inline: ${spacing(1)};
  flex-grow: 1;
`
